import React, { Component } from "react";
import PropTypes from "prop-types";

import SvgIcon from "components/Common/SvgIcon";
import Button from "components/Common/Button";
import Notification from "components/Common/Notification";
import { NO_OP_FUNCTION } from "services/helpers";
import "./style.scss";

class LoginSplash extends Component {
  /**
   * @returns {SVGElement}
   */
  getIcon() {
    const {
      icon,
      fillColor,
      strokeDashArray,
      stroke
    } = this.props;

    return (
      <SvgIcon
        icon={icon}
        customClassName="Splash__icon"
        fillColor={fillColor}
        strokeDashArray={strokeDashArray}
        stroke={stroke}
      />
    );
  }

  /**
   * @returns {HTMLObjectElement}
   */
  getButton() {
    const { button } = this.props;

    return (
      <Button
        icon={button.icon}
        text={button.label}
        onClick={button.action}
        isLoading={button.isLoading}
        disabled={button.disabled}
      />
    );
  }

  /**
   * @returns {HTMLObjectElement}
   */
  render() {
    const {
      title, icon, button, children, description, showError, resetNotificationError, errorMessage
    } = this.props;

    return (
      <div className="LoginSplash">
        {icon && this.getIcon()}
        <h1 className="LoginSplash__header">{title}</h1>

        {showError && (
          <Notification
            description={errorMessage}
            notificationType="error"
            customClassName="Login__notification"
            onClose={resetNotificationError}
          />
        )}
        <p className="LoginSplash__description">{description}</p>
        {children}
        {button.label && this.getButton()}
      </div>
    );
  }
}

LoginSplash.defaultProps = {
  button: [],
  children: undefined,
  errorMessage: "",
  fillColor: "currentColor",
  icon: "",
  resetNotificationError: NO_OP_FUNCTION,
  showError: false,
  stroke: "",
  strokeDashArray: ""
};

LoginSplash.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
    icon: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  children: PropTypes.node,
  description: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]).isRequired,
  fillColor: PropTypes.string,
  icon: PropTypes.string,
  resetNotificationError: PropTypes.func,
  stroke: PropTypes.string,
  showError: PropTypes.bool,
  strokeDashArray: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default LoginSplash;
